import { combineReducers } from 'redux';
import { clientAccessActionTypes } from './ClientAccess.actionTypes';

const listInitialState = {
  pending: false,
  success: false,
  failure: false,
  data: [],
};

const listReducer = (state = listInitialState, action) => {
  switch (action.type) {
    case clientAccessActionTypes.GET_TEAM_CLIENTS_PENDING:
      return { ...state, pending: true, success: false, failure: false };
    case clientAccessActionTypes.GET_TEAM_CLIENTS_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
        failure: false,
        data: action.payload,
      };
    case clientAccessActionTypes.GET_TEAM_CLIENTS_FAILED:
      return { ...state, pending: false, success: false, failure: true };
    default:
      return state;
  }
};

const revokeInitialState = {
  pending: false,
  success: false,
  failure: false,
  failurePayload: {},
};

const revokeReducer = (state = revokeInitialState, action) => {
  switch (action.type) {
    case clientAccessActionTypes.REVOKE_CLIENT_ACCESS_PENDING:
      return { ...state, pending: true, success: false, failure: false };
    case clientAccessActionTypes.REVOKE_CLIENT_ACCESS_SUCCESS:
      return { ...state, pending: false, success: true, failure: false };
    case clientAccessActionTypes.REVOKE_CLIENT_ACCESS_FAILED:
      return {
        ...state,
        pending: false,
        success: false,
        failure: true,
        failurePayload: action.payload,
      };
    default:
      return state;
  }
};

const clientAccessReducer = combineReducers({
  list: listReducer,
  revoke: revokeReducer,
});

export default clientAccessReducer;
